import React from 'react';
import { store } from 'Models/Store';
import { FormattedMessage } from 'react-intl';
import { Navigate, NavigateFunction } from 'react-router-dom';
import { newAlertModal } from 'Views/Components/Modal/NewAlertModal';
import { appConfigStore } from 'Models/AppConfigStore';

const DEFAULT_TITLE = 'Update your account details';
// eslint-disable-next-line max-len
const DEFAULT_BODY =
	'It looks like your account is missing some important details, such as your mobile number. Please update your information to ensure a smooth experience.';
const DEFAULT_ACTION_TEXT = 'Update now';

export const checkUserDetailsAndShowPopup = (navigate: NavigateFunction) => {
	const { userPostcodeEnabled, userPhoneEnabled, userPhoneRequired } = appConfigStore;
	if (store.isSuper) {
		return;
	}

	// Don't show popup if user is in the booking wizard
	if (window.location.pathname.includes('/booking-wizard')) {
		return;
	}

	const mandatoryDetails = [store.userData?.firstName, store.userData?.lastName, store.userData?.email];

	// We don't care if staff+ have a phone number or postcode on their account or not
	if (userPhoneEnabled && userPhoneRequired && !store.isStaff) {
		mandatoryDetails.push(store.userData?.phone);
	}

	if (userPostcodeEnabled && !store.isStaff) {
		mandatoryDetails.push(store.userData?.postcode);
	}

	if (mandatoryDetails.filter(detail => !!detail).length === mandatoryDetails.length) {
		return;
	}

	newAlertModal(
		<FormattedMessage id="post-login__missing-details-popup__title" defaultMessage={DEFAULT_TITLE} />,
		<p>
			<FormattedMessage id="post-login__missing-details-popup__body" defaultMessage={DEFAULT_BODY} />
		</p>,
		{
			cancelText: (
				<FormattedMessage id="post-login__missing-details-popup__button" defaultMessage={DEFAULT_ACTION_TEXT} />
			),
			label: DEFAULT_TITLE,
		},
	)
		.then(() => {
			// User wants to update now
			navigate('/account-details/account?mode=edit');
		})
		.catch(() => {
			// Handle rejects
		});
};
